import { Button } from "@/components/ui/Button";
import { useIsMobile } from "@/hooks/useBreakpoint";
import { useForceStore } from "@/store/forceStore";
import { ElementBrowser } from "./ElementBrowser";
import { FactionSelector } from "./FactionSelector";
import { ValidationPanel } from "./ValidationPanel";
import { VehicleBrowser } from "./VehicleBrowser";

export function Sidebar() {
	const resetForce = useForceStore((s) => s.resetForce);
	const isMobile = useIsMobile();

	return (
		<aside
			className={
				isMobile
					? "flex flex-col h-full overflow-hidden"
					: "w-[var(--sidebar-width)] bg-bg-secondary border-r border-border-default flex flex-col shrink-0 h-full overflow-hidden"
			}
		>
			<div className="flex-1 overflow-y-auto p-4 space-y-6">
				<FactionSelector />
				<ElementBrowser />
				<VehicleBrowser />
				{/* Validation panel only in sidebar on desktop */}
				{!isMobile && <ValidationPanel />}
			</div>
			<div className="p-4 border-t border-border-default">
				<Button variant="danger" size="sm" className="w-full" onClick={resetForce}>
					Reset Force
				</Button>
			</div>
		</aside>
	);
}
